var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonChimeVoiceConnector32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Chime-Voice-Connector_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Chime-Voice-Connector_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33,23.224 L25,20.912 L25,18.027 L33,20.354 L33,23.224 Z M29.225,29.758 L27.285,31.696 L23.306,24.561 L25.254,22.613 L29.225,29.758 Z M22.452,24 L18.712,24 C18.489,24 18.293,24.148 18.231,24.362 L18.159,24.612 L16,22.453 L16,18.713 C16,18.49 15.853,18.294 15.639,18.232 L15.389,18.16 L17.548,16 L21.288,16 C21.511,16 21.707,15.853 21.769,15.639 L21.841,15.389 L24,17.548 L24,21.288 C24,21.511 24.147,21.706 24.361,21.768 L24.611,21.841 L22.452,24 Z M19.646,33 L16.776,33 L19.088,25 L21.974,25 L19.646,33 Z M10.242,29.224 L8.304,27.286 L15.439,23.306 L17.388,25.255 L10.242,29.224 Z M7,19.646 L7,16.777 L15,19.089 L15,21.974 L7,19.646 Z M10.775,10.243 L12.715,8.305 L16.694,15.439 L14.746,17.388 L10.775,10.243 Z M20.354,7 L23.224,7 L20.912,15 L18.026,15 L20.354,7 Z M29.758,10.776 L31.696,12.715 L24.561,16.695 L22.612,14.746 L29.758,10.776 Z M33.64,19.499 L25.719,17.194 L32.761,13.266 C32.898,13.189 32.991,13.053 33.013,12.898 C33.034,12.743 32.982,12.586 32.871,12.475 L30.198,9.803 C30.041,9.645 29.797,9.611 29.602,9.719 L22.309,13.771 L24.369,6.639 C24.413,6.488 24.383,6.326 24.288,6.2 C24.193,6.074 24.046,6 23.889,6 L19.979,6 C19.756,6 19.561,6.147 19.498,6.361 L17.194,14.282 L13.266,7.24 C13.189,7.103 13.054,7.01 12.898,6.988 C12.736,6.966 12.587,7.019 12.476,7.13 L9.802,9.803 C9.644,9.96 9.609,10.204 9.718,10.399 L13.771,17.693 L6.639,15.631 C6.488,15.589 6.326,15.618 6.199,15.712 C6.074,15.807 6,15.954 6,16.112 L6,20.022 C6,20.244 6.146,20.44 6.36,20.502 L14.281,22.807 L7.239,26.735 C7.102,26.811 7.009,26.948 6.987,27.103 C6.966,27.258 7.018,27.414 7.129,27.525 L9.802,30.198 C9.959,30.356 10.205,30.391 10.398,30.282 L17.691,26.23 L15.631,33.362 C15.587,33.513 15.617,33.675 15.712,33.801 C15.807,33.927 15.954,34 16.111,34 L20.021,34 C20.244,34 20.439,33.853 20.502,33.64 L22.806,25.719 L26.734,32.761 C26.811,32.898 26.946,32.991 27.102,33.013 C27.264,33.035 27.413,32.981 27.524,32.871 L30.198,30.198 C30.356,30.04 30.391,29.797 30.282,29.602 L26.229,22.308 L33.361,24.37 C33.514,24.414 33.675,24.384 33.801,24.288 C33.926,24.194 34,24.046 34,23.889 L34,19.979 C34,19.757 33.854,19.561 33.64,19.499 L33.64,19.499 Z",
    id: "Amazon-Chime_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonChimeVoiceConnector32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Chime-Voice-Connector_32.924a23f0bc963ab6a768abaeec9459ec.svg";
export { ForwardRef as ReactComponent };